import { useEffect, useState } from "react";
import { getShareLink } from "@/apis/bacchus/segment";
import type { ShareLink } from "@/apis/bacchus/shareTypes";

/** The segment's current share link (null when never shared). Only the
 * segment's creator may read it, so `enabled` must reflect write access. */
export function useSegmentShareLink(
  segmentId: string | undefined,
  enabled: boolean
) {
  const [link, setLink] = useState<ShareLink | null>(null);

  useEffect(() => {
    setLink(null);
    if (!segmentId || !enabled) return;
    let cancelled = false;
    getShareLink(segmentId)
      .then((result) => {
        if (!cancelled) setLink(result);
      })
      .catch((err) => console.error("Failed to load share link:", err));
    return () => {
      cancelled = true;
    };
  }, [segmentId, enabled]);

  return { link, setLink };
}
